'use strict';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import {getPeopleList} from '../reducers/state';
import {buildPeopleList, REDUX_OPTIONS} from './peopleConfig';
import {PEOPLE_LIST_PREFIX} from './state';


/** @type {ReduxList} */
export const reduxList = buildPeopleList({
  prefix: PEOPLE_LIST_PREFIX,
  getState: getPeopleList,
  listPath: parentId => `organizations/${parentId}/people`,
  listSyncPath: parentId => `organizations/${parentId}/people/${SYNC_PATH}`,
  deleteItemPath: (itemId, payload) => `${payload.collection}/${itemId}`,
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  ...REDUX_OPTIONS,
});



// WEBPACK FOOTER //
// ./src/js/personnel/redux/peopleList.js